/**
 * GitLab Pipeline Topology 常量配置
 * 参考 Tekton 的配置
 */

export const NODE_HEIGHT = 33;
export const NODE_WIDTH = 180;
export const DROP_SHADOW_SPACING = 4;
export const GRAPH_MIN_WIDTH = 300;
export const TOOLBAR_HEIGHT = 40;

export enum PipelineLayout {
  DAGRE = 'Dagre',
}

